import type { TeamsFilterKey } from '@/common/api/types/itemFilters';

export const TEAMS_PICKLIST_FILTERS = [
  'roleId',
  'loopId',
  'skillId',
] as const satisfies readonly TeamsFilterKey[];

export const getTeamsTableFilters = () => [...TEAMS_PICKLIST_FILTERS] as const;
